import { Component} from '@angular/core';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {DialogRecComponent} from './dialog-rec/dialog-rec.component';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  cavities = 0;
  extractions = 0;
  root_canals = 0;
  implants = 0;
  waiting_period = true;

  extractions_cost = 650;
  cavity_cost = 181.14;
  implant_cost = 2131.63;
  root_canal_cost = 1255.36;

  getBestPlanScore(plan: any) {
    var constantCost = plan.premium * 12 + plan.deductible;
    var variableCost = (((this.cavities * this.cavity_cost + this.extractions 
      * this.extractions_cost) 
      * plan.basic_services_precent) 
      + ((this.root_canals * this.root_canal_cost) 
      + (this.implants * this.implant_cost)) * plan.major_services_precent);
    if (variableCost == 0) {
      constantCost -= plan.deductible;
    }

    var variableTotal = 0;
    if (variableCost > plan.coverage_amount) {
      variableTotal = variableCost - plan.coverage_amount;
    }
    return constantCost + variableTotal;
  }


  title = 'insurance-app-hacknc19';

  constructor(public dialog: MatDialog) { }

  user_preferences = [
    {
      name: 'Low Premiums',
      description: 'Premiums are how much you pay per month'
    },
    {
      name: 'Low Deductibles',
      description: 'Deductibles are how much you pay before you can' +
        ' recieve treatment'
    },
    {
      name: 'Best Basic Converage',
      description: 'E.g: Filling, Extractions'
    },
    {
      name: 'Best Premier Converage',
      description: 'E.g: Root canals, Oral Implants'
    },
  ];

  insurance_plans = [
    {
      name: "UnitedHealthcare", 
      description: "Designed to offer coverage for preventive care services immediately coverage for basic " + "services after a 4-month waiting period. Plan availability varies by state.",
      plan: "Essential",
      premium: 21.50,
      deductible: 50,
      basic_services_precent: .5,
      major_services_precent: 1.0,
      coverage_amount: 1000,
      src: "../assets/images/Essential.png",
      waiting_period: true,
      orthodontist_percent: 1.0
      },
      {
      name: "UnitedHealthcare", 
      plan: "Essential Preferred",
      description: "This plan adds coverage for major services after a 6-month waiting " + "period. There is also no waiting period for preventive care services.",
      premium: 33.84,
      deductible: 100,
      basic_services_precent: .5,
      major_services_precent: 0.85,
      coverage_amount: 1000,
      src: "../assets/images/Essential Preferred.png",
      waiting_period: true,
      orthodontist_percent: 1.0
      },
      {
      name: "UnitedHealthcare", 
      plan: "Primary",
      description: "Designed to offer immediate coverage and network discounts for " + 
      "preventive care and basic services. Plan availability varies by state.",
      premium: 25.85,
      deductible: 50,
      basic_services_precent: .5,
      major_services_precent: 1.0,
      coverage_amount: 1000,
      src: "../assets/images/Primary.png",
      waiting_period: false,
      orthodontist_percent: 1.0
      },
      {
      name: "UnitedHealthcare", 
      plan: "Primary Preferred",
      description: "Major services are covered, after a 6-month waiting period, using " + "dentists. Plan availability varies by state.",
      premium: 38.78,
      deductible: 50,
      basic_services_precent: .35,
      major_services_precent: .85,
      coverage_amount: 1000,
      src: "../assets/images/Primary Preferred.png",
      waiting_period: false,
      orthodontist_percent: 1.0
      },
      {
      name: "UnitedHealthcare", 
      plan: "Premier",
      description: "Designed to offer immediate coverage and network discounts for " + 
      "preventive care, basic and major services.",
      premium: 41.06,
      deductible: 50,
      basic_services_precent: .5,
      major_services_precent: .4,
      coverage_amount: 1500,
      src: "../assets/images/Premier.png",
      waiting_period: false,
      orthodontist_percent: 1.0
      },
      {
      name: "UnitedHealthcare", 
      plan: "Premier Elite",
      description: "This plan pays more for major services after a 6-month waiting " + 
      "period. There is no waiting period for preventive care or basic services.",
      premium: 41.17,
      deductible: 50,
      basic_services_precent: .5,
      major_services_precent: .85,
      coverage_amount: 2000,
      src: "../assets/images/Premier Elite.png",
      waiting_period: false,
      orthodontist_percent: 1.0
      },
      {
      name: "UnitedHealthcare", 
      plan: "Premier Plus",
      description: "With orthodontic care for dependents plus coverage for dental " + 
      "implants under Major Services, this is the most comprehensive plan.",
      premium: 41.17,
      deductible: 50,
      basic_services_precent: .65,
      major_services_precent: .9,
      coverage_amount: 2000,
      src: "../assets/images/Premier Plus.png",
      waiting_period: true,
      orthodontist_percent: .5
      },
      {
      name: "BlueCrossBlueShield", 
      plan: "Dental Blue",
      description: "Get broad dental coverage at an affordable rate.",
      premium: 37.88,
      deductible: 75,
      basic_services_precent: .3,
      major_services_precent: .5,
      coverage_amount: 1000,
      src: "../assets/images/Dental Blue.png",
      waiting_period: false,
      orthodontist_percent: 1.0
      },
      {
      name: "Cigna", 
      plan: "Cigna 1500",
      description: "Highest level of dental coverage for planned and unplanned care.",
      premium: 50.00,
      deductible: 50,
      basic_services_precent: .2,
      major_services_precent: .5,
      coverage_amount: 1500,
      src: "../assets/images/Cigna 1500.png",
      waiting_period: true,
      orthodontist_percent: 1.0
      },
      {
      name: "Cigna", 
      plan: "Cigna 1000",
      description: "Same quality provider network with lower premium.",
      premium: 30.00,
      deductible: 50,
      basic_services_precent: .2,
      major_services_precent: .5,
      coverage_amount: 1000,
      src: "../assets/images/CignaLogo.png",
      waiting_period: true,
      orthodontist_percent: 1.0
      },
      {
      name: "Cigna", 
      plan: "Cigna Preventive",
      description: "Coverage to maintain your dental health.",
      premium: 38.00,
      deductible: 0,
      basic_services_precent: 1.0,
      major_services_precent: 1.0,
      coverage_amount: 0,
      src: "../assets/images/CignaLogo.png",
      waiting_period: false,
      orthodontist_percent: 1.0
      },
      {
      name: "Humana", 
      plan: "Preventive Value",
      description: "Designed for people who are looking to maintain their oral health " + "through regular dental exams and cleanings.",
      premium: 25,
      deductible: 50,
      basic_services_precent: .5,
      major_services_precent: 1.0,
      coverage_amount: 1000,
      src: "../assets/images/Preventive Value.png",
      waiting_period: false,
      orthodontist_percent: 1.0
      },
      {
      name: "Humana", 
      plan: "Preventive Plus",
      description: "Designed for people who believe in the importance of regular dental " + "exams and cleanings. Offers affordable coverage for preventive, basic, and major " + "services.",
      premium: 28.99,
      deductible: 50,
      basic_services_precent: .5,
      major_services_precent: .7,
      coverage_amount: 1000,
      src: "../assets/images/Preventive Plus.png",
      waiting_period: true,
      orthodontist_percent: 1.0
      }
    ];
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.user_preferences, event.previousIndex, event.currentIndex);
  }
  sortStableByPremium(insurance_plans: any[]) {
    insurance_plans = insurance_plans.map(function(data, idx){
      return {idx:idx, data:data}
    });
    insurance_plans.sort(function(a, b) {
      if (a.data.premium < b.data.premium) return -1;
      if (a.data.premium > b.data.premium) return 1;
      return a.idx - b.idx
    });
    
    var answer = insurance_plans.map(function(val){
        return val.data
    });

    return answer;
  }
  sortStableByDeductible(insurance_plans: any[]) {
    insurance_plans = insurance_plans.map(function(data, idx){
      return {idx:idx, data:data}
    });
    insurance_plans.sort(function(a, b) {
      if (a.data.deductible < b.data.deductible) return -1;
      if (a.data.deductible > b.data.deductible) return 1;
      return a.idx - b.idx
    });
    
    var answer = insurance_plans.map(function(val){
        return val.data
    });
    return answer;
  }
  sortStableByPremier(insurance_plans: any[]) {
    insurance_plans = insurance_plans.map(function(data, idx){
      return {idx:idx, data:data}
    });
    insurance_plans.sort(function(a, b) {
      if (a.data.major_services_precent < b.data.major_services_precent) return -1;
      if (a.data.major_services_precent > b.data.major_services_precent) return 1;
      return a.idx - b.idx
    });
    
    var answer = insurance_plans.map(function(val){
        return val.data
    });
    return answer;
  }
  sortStableByBasic(insurance_plans: any[]) {
    insurance_plans = insurance_plans.map(function(data, idx){
      return {idx:idx, data:data}
    });
    insurance_plans.sort(function(a, b) {
      if (a.data.basic_services_precent < b.data.basic_services_precent) return -1;
      if (a.data.basic_services_precent > b.data.basic_services_precent) return 1;
      return a.idx - b.idx
    });
    
    var answer = insurance_plans.map(function(val){
        return val.data
    });
    return answer;
  }
  sortIndexImportant(insurance_plan: any[], index: number) {
    if (this.user_preferences[index].name === "Low Premiums") {
      insurance_plan = this.sortStableByPremium(insurance_plan); 
    } else if (this.user_preferences[index].name == "Low Deductibles") {
      insurance_plan = this.sortStableByDeductible(insurance_plan);  
    } else if (this.user_preferences[index].name == "Best Basic Converage") {
      insurance_plan = this.sortStableByBasic(insurance_plan);
    } else if (this.user_preferences[index].name == "Best Premier Converage") {
      insurance_plan = this.sortStableByPremier(insurance_plan); 
    } else {
      console.log("ERRROR, user pref no match");
      return insurance_plan; 
    }
    return insurance_plan
  }
  openDialog(isRanked: boolean): void {
    // Process Insurance Plans
    var copy_insurance_plans = this.insurance_plans.slice();
    var totalCost = -1;

    if (isRanked) {
      copy_insurance_plans = this.sortIndexImportant(copy_insurance_plans, 3);
      copy_insurance_plans = this.sortIndexImportant(copy_insurance_plans, 2);
      copy_insurance_plans = this.sortIndexImportant(copy_insurance_plans, 1);
      copy_insurance_plans = this.sortIndexImportant(copy_insurance_plans, 0);
    } else {
      var lowestScore = Number.MAX_VALUE;
      var bestPlan = copy_insurance_plans[0];
      for (var plan of this.insurance_plans) {
        var score = this.getBestPlanScore(plan);
        if (score < lowestScore) {
          lowestScore = score;
          bestPlan = plan;
        }
      }
      totalCost = lowestScore;
      copy_insurance_plans = [];
      copy_insurance_plans.push(bestPlan);
    }


    const dialogRef = this.dialog.open(DialogRecComponent, {
      width: '500px',
      data: {
        insurance_plans: copy_insurance_plans,
        totalCost: totalCost
      }
});

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }
}

